import React from "react";
const icon = (
  <svg
    width="576"
    height="512"
    viewBox="0 0 576 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M512 80C520.8 80 528 87.2 528 96V416C528 424.8 520.8 432 512 432H64C55.2 432 48 424.8 48 416V96C48 87.2 55.2 80 64 80H512ZM64 32C28.7 32 0 60.7 0 96V416C0 451.3 28.7 480 64 480H512C547.3 480 576 451.3 576 416V96C576 60.7 547.3 32 512 32H64ZM208 256C224.974 256 241.253 249.257 253.255 237.255C265.257 225.253 272 208.974 272 192C272 175.026 265.257 158.747 253.255 146.745C241.253 134.743 224.974 128 208 128C191.026 128 174.747 134.743 162.745 146.745C150.743 158.747 144 175.026 144 192C144 208.974 150.743 225.253 162.745 237.255C174.747 249.257 191.026 256 208 256ZM176 288C131.8 288 96 323.8 96 368C96 376.8 103.2 384 112 384H304C312.8 384 320 376.8 320 368C320 323.8 284.2 288 240 288H176ZM376 144C362.7 144 352 154.7 352 168C352 181.3 362.7 192 376 192H456C469.3 192 480 181.3 480 168C480 154.7 469.3 144 456 144H376ZM376 240C362.7 240 352 250.7 352 264C352 277.3 362.7 288 376 288H456C469.3 288 480 277.3 480 264C480 250.7 469.3 240 456 240H376Z"
      fill="#8803E9"
    />
  </svg>
);

export default icon;
